import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'

import Home from '@/views/Home'
import Diagnostic from '@/views/Diagnostic'
import Marketing from '@/views/Marketing'
import Channels from '@/views/Channels'
import CustomResource from '@/views/CustomResource'
import Comunication from '@/views/Comunication'
import ComunicationForm from '@/views/ComunicationForm'
import Account from '@/views/Account'
import Users from '@/views/Users'
import Config from '@/views/Config'
import Category from '@/views/Category'
import Document from '@/views/Document'
import Search from '@/views/Search'
import Login from '@/views/Login'
import Remember from '@/views/Remember'
import Cart from '@/views/Cart'
import Orders from '@/views/Orders'
import Order from '@/views/Order'
import Notifications from '@/views/Notifications'
import Shortener from '@/views/Shortener'
import ChangePass from '@/views/ChangePassword'
import Admin_Restaurants from '@/views/admin/Restaurants'
import Admin_Users from '@/views/admin/Users'
import Admin_Sections from '@/views/admin/Sections'
import Admin_Resources from '@/views/admin/Resources'
import Admin_Orders from '@/views/admin/Orders'
import Admin_Mop from '@/views/admin/Mop'
import Admin_Sliders from '@/views/admin/Sliders'
import Admin_Videos from '@/views/admin/Videos'
import Admin_Import from '@/views/admin/Import'
import Admin_Informs from '@/views/admin/Informs'
import Partner_Reports from '@/views/partner/Reports'
import OrderDetails from '@/views/OrderDetails'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: requireAuth
    },
    {
      path: '/config',
      name: 'xonfig',
      component: Config,
      beforeEnter: requireAuth
    },
    {
      path: '/diagnostic',
      name: 'diagnostic',
      component: Diagnostic,
      beforeEnter: (to, from, next) => {
        requireAuth(to, from, () => {
          checkMarketAccess(to, from, next);
        });
      },
      props: { type: 1 }
    },
    {
      path: '/marketing',
      name: 'marketing',
      component: Marketing,
      beforeEnter: (to, from, next) => {
        requireAuth(to, from, () => {
          checkMarketAccess(to, from, next);
        });
      },
      props: { type: 1 }
    },
    {
      path: '/channels',
      name: 'channels',
      component: Channels,
      beforeEnter: requireAuth,
      props: { type: 1 }
    },
    {
      path: '/toolkits',
      name: 'toolkits',
      component: Document,
      beforeEnter: requireAuth,
      props: { type: 4 }
    },
    {
      path: '/toolkits/:category',
      name: 'toolkits_category',
      component: Document,
      beforeEnter: requireAuth,
      props: { type: 4 }
    },
    {
      path: '/toolkits/:category/:resource',
      name: 'toolkits_category_resource',
      component: Document,
      beforeEnter: requireAuth,
      props: { type: 4 }
    },
    {
      path: '/practices',
      name: 'practices',
      component: Document,
      beforeEnter: requireAuth,
      props: { type: 5 }
    },
    {
      path: '/practices/:category',
      name: 'practices_category',
      component: Document,
      beforeEnter: requireAuth,
      props: { type: 5 }
    },
    {
      path: '/practices/:category/:resource',
      name: 'practices_category_resource',
      component: Document,
      beforeEnter: requireAuth,
      props: { type: 5 }
    },
    {
      path: '/account',
      name: 'account',
      component: Account,
      beforeEnter: requireAuth,
      props: { type: 1 }
    },
    {
      path: '/nacional',
      name: 'category',
      component: Category,
      beforeEnter: requireAuth,
      props: { type: 1 }
    },
    {
      path: '/nacional/:category',
      name: 'nacional_category',
      component: Category,
      beforeEnter: requireAuth,
      props: { type: 1 }
    },
    {
      path: '/nacional/:category/:resource',
      name: 'nacional_category_resource',
      component: Category,
      beforeEnter: requireAuth,
      props: { type: 1 }
    },
    {
      path: '/local',
      name: 'local',
      component: Category,
      beforeEnter: requireAuth,
      props: { type: 2 }
    },
    {
      path: '/local/:category',
      name: 'local_category',
      component: Category,
      beforeEnter: requireAuth,
      props: { type: 2 }
    },
    {
      path: '/local/:category/:resource',
      name: 'local_category_resource',
      component: Category,
      beforeEnter: requireAuth,
      props: { type: 2 }
    },
    {
      path: '/customresource',
      name: 'customresource',
      component: CustomResource,
      beforeEnter: requireAuth
    },
    {
      path: '/comunicacion',
      name: 'comunicacion',
      component: Category,
      beforeEnter: requireAuth,
      props: { type: 3 }
    },
    {
      path: '/comunicacion/:category',
      name: 'comunicacion_category',
      component: Category,
      beforeEnter: requireAuth,
      props: { type: 3 }
    },
    {
      path: '/comunicacion/form',
      name: 'comunicacion_form',
      component: ComunicationForm,
      beforeEnter: requireAuth
    },
    {
      path: '/comunicacion/:category/:resource',
      name: 'comunicacion_category_resource',
      component: Category,
      beforeEnter: requireAuth,
      props: { type: 3 }
    },
    {
      path: '/search',
      name: 'search',
      component: Search,
      beforeEnter: requireAuth
    },
    {
      path: '/cart',
      name: 'cart',
      component: Cart,
      beforeEnter: requireAuth
    },
    {
      path: '/orders',
      name: 'orders',
      component: Orders,
      beforeEnter: requireAuth
    },
    {
      path: '/order/:id',
      name: 'order',
      component: Order,
      beforeEnter: requireAuth,
      props: { type: 'new' }
    },
    {
      path: '/order/edit/:id',
      name: 'order_edit',
      component: Order,
      beforeEnter: requireAuth,
      props: { type: 'edit' }
    },
    {
      path: '/users',
      name: 'user',
      component: Users,
      beforeEnter: requireAuth
    },
    {
      path: '/users/add',
      name: 'user_add',
      component: Users,
      beforeEnter: requireAuth
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        layout: 'login'
      }
    },
    {
      path: '/remember',
      name: 'remember',
      component: Remember,
      meta: {
        layout: 'login'
      }
    },
    {
      path: '/changepassword/:id/:time',
      name: 'changepassword',
      component: ChangePass,
      meta: {
        layout: 'login'
      }
    },
    {
      path: '/notifications',
      name: 'notifications',
      component: Notifications,
      beforeEnter: requireAuth
    },

    // ADMIN
    {
      path: '/admin',
      name: 'admin',
      redirect: { name: 'resources' },
      component: Home,
      beforeEnter: requireAuth,
      meta: {
        layout: 'admin',
        permission: 'admin'
      }
    },
    {
      path: '/admin/restaurants',
      name: 'restaurants',
      props: { page: 'list' },
      component: Admin_Restaurants,
      beforeEnter: requireAuth,
      meta: {
        layout: 'admin',
        permission: 'admin'
      }
    },
    {
      path: '/admin/restaurants/add',
      name: 'restaurants_add',
      props: { page: 'add' },
      component: Admin_Restaurants,
      beforeEnter: requireAuth,
      meta: {
        layout: 'admin',
        permission: 'admin'
      }
    },
    {
      path: '/admin/restaurants/:id',
      name: 'restaurants_edit',
      props: { page: 'edit' },
      component: Admin_Restaurants,
      beforeEnter: requireAuth,
      meta: {
        layout: 'admin',
        permission: 'admin'
      }
    },
    {
      path: '/admin/users',
      name: 'users',
      props: { page: 'list' },
      component: Admin_Users,
      beforeEnter: requireAuth,
      meta: {
        layout: 'admin',
        permission: 'admin'
      }
    },
    {
      path: '/admin/users/add',
      name: 'users_add',
      props: { page: 'add' },
      component: Admin_Users,
      beforeEnter: requireAuth,
      meta: {
        layout: 'admin',
        permission: 'admin'
      }
    },
    {
      path: '/admin/users/:id',
      name: 'users_edit',
      props: { page: 'edit' },
      component: Admin_Users,
      beforeEnter: requireAuth,
      meta: {
        layout: 'admin',
        permission: 'admin'
      }
    },
    {
      path: '/admin/sections',
      name: 'sections',
      props: { page: 'list' },
      component: Admin_Sections,
      beforeEnter: requireAuth,
      meta: {
        layout: 'admin',
        permission: 'admin'
      }
    },
    {
      path: '/admin/section/add',
      name: 'sections_add',
      props: { page: 'add' },
      component: Admin_Sections,
      beforeEnter: requireAuth,
      meta: {
        layout: 'admin',
        permission: 'admin'
      }
    },
    {
      path: '/admin/section/:id',
      name: 'sections_edit',
      props: { page: 'edit' },
      component: Admin_Sections,
      beforeEnter: requireAuth,
      meta: {
        layout: 'admin',
        permission: 'admin'
      }
    },
    {
      path: '/admin/resources',
      name: 'resources',
      props: { page: 'list' },
      component: Admin_Resources,
      beforeEnter: requireAuth,
      meta: {
        layout: 'admin',
        permission: 'admin'
      }
    },
    {
      path: '/admin/resources/add',
      name: 'resources_add',
      props: { page: 'add' },
      component: Admin_Resources,
      beforeEnter: requireAuth,
      meta: {
        layout: 'admin',
        permission: 'admin'
      }
    },
    {
      path: '/admin/resources/:id',
      name: 'resources_edit',
      props: { page: 'edit' },
      component: Admin_Resources,
      beforeEnter: requireAuth,
      meta: {
        layout: 'admin',
        permission: 'admin'
      }
    },
    {
      path: '/admin/orders',
      name: 'admin_orders',
      component: Admin_Orders,
      beforeEnter: requireAuth,
      meta: {
        layout: 'admin',
        permission: 'admin'
      }
    },
    {
      path: '/admin/orders/:id',
      name: 'orders_edit',
      props: { page: 'edit' },
      component: Admin_Orders,
      beforeEnter: requireAuth,
      meta: {
        layout: 'admin',
        permission: 'admin'
      }
    },
    {
      path: '/admin/mop',
      name: 'admin_mop',
      component: Admin_Mop,
      beforeEnter: (to, from, next) => {
        requireAuth(to, from, () => {
          checkAdminMarketAccess(to, from, next);
        });
      },
      meta: {
        layout: 'admin',
        permission: 'admin'
      }
    },
    {
      path: '/admin/sliders',
      name: 'sliders',
      props: { page: 'list' },
      component: Admin_Sliders,
      beforeEnter: requireAuth,
      meta: {
        layout: 'admin',
        permission: 'admin'
      }
    },
    {
      path: '/admin/sliders/add',
      name: 'sliders_add',
      props: { page: 'add' },
      component: Admin_Sliders,
      beforeEnter: requireAuth,
      meta: {
        layout: 'admin',
        permission: 'admin'
      }
    },
    {
      path: '/admin/sliders/:id',
      name: 'sliders_edit',
      props: { page: 'edit' },
      component: Admin_Sliders,
      beforeEnter: requireAuth,
      meta: {
        layout: 'admin',
        permission: 'admin'
      }
    },
    {
      path: '/admin/inform',
      name: 'inform',
      props: { page: 'list' },
      component: Admin_Informs,
      beforeEnter: requireAuth,
      meta: {
        layout: 'admin',
        permission: 'admin'
      }
    },
    {
      path: '/admin/import',
      name: 'import',
      component: Admin_Import,
      beforeEnter: (to, from, next) => {
        requireAuth(to, from, () => {
          checkAdminMarketAccess(to, from, next);
        });
      },
      meta: {
        layout: 'admin',
        permission: 'admin'
      }
    },
    {
      path: '/admin/videos',
      name: 'videos',
      props: { page: 'list' },
      component: Admin_Videos,
      beforeEnter: (to, from, next) => {
        requireAuth(to, from, () => {
          checkAdminMarketAccess(to, from, next);
        });
      },
      meta: {
        layout: 'admin',
        permission: 'admin'
      }
    },
    {
      path: '/admin/videos/add',
      name: 'videos_add',
      props: { page: 'add' },
      component: Admin_Videos,
      beforeEnter: (to, from, next) => {
        requireAuth(to, from, () => {
          checkAdminMarketAccess(to, from, next);
        });
      },
      meta: {
        layout: 'admin',
        permission: 'admin'
      }
    },
    {
      path: '/admin/videos/:id',
      name: 'videos_edit',
      props: { page: 'edit' },
      component: Admin_Videos,
      beforeEnter: (to, from, next) => {
        requireAuth(to, from, () => {
          checkAdminMarketAccess(to, from, next);
        });
      },
      meta: {
        layout: 'admin',
        permission: 'admin'
      }
    },
    {
      path: '/r/:id',
      name: 'shortener',
      component: Shortener,
      meta: {
        layout: 'login'
      }
    },
    {
      path: '/r/:id/:user_id',
      name: 'shortener',
      component: Shortener,
      meta: {
        layout: 'login'
      }
    },
    // PARTNER
    {
      path: '/partner/reports',
      name: 'reports',
      props: { page: 'report' },
      component: Partner_Reports,
      beforeEnter: requireAuth,
      meta: {
        layout: 'partner',
        permission: 'partner'
      }
    },
    {
      path: '/partner/reports/add',
      name: 'reports_add',
      props: { page: 'add' },
      component: Partner_Reports,
      beforeEnter: requireAuth,
      meta: {
        layout: 'partner',
        permission: 'partner'
      }
    },
    {
      path: '/partner/reports/:date',
      name: 'reports_edit',
      props: { page: 'edit' },
      component: Partner_Reports,
      beforeEnter: requireAuth,
      meta: {
        layout: 'partner',
        permission: 'partner'
      }
    },
    {
      path: '/order/details/:id',
      name: 'order_details',
      component: OrderDetails,
      beforeEnter: requireAuth,
      props: true
    },
    {
      path: '*',
      beforeEnter: redirectHome
    },
    {
      path: '/inituserlogin/:id',
      name: 'LoginUserCallback',
      beforeEnter: loginUserCallbackAccess,
      meta: {
          layout: 'login'
      }
    },
    {
        path: '/logoutexternal',
        name: 'LoginUserCallback',
        beforeEnter: logoutUserCallbackAccess,
        meta: {
            layout: 'login'
        }
    }
  ]
})

/*
    This will cehck to see if the user is authenticated or not.
*/
function requireAuth (to, from, next) {
  // console.log( "requireAuth User state: " + store.getters['user/getUserLoadStatus']() );
  // console.log( store );
  /*
      Determines where we should send the user.
    */
  function proceed () {
    /*
          If the user has been loaded determine where we should
          send the user.
        */
    if (store.getters['user/getUserLoadStatus']() == 2) {
      /*
              If the user is not empty, that means there's a user
              authenticated we allow them to continue. Otherwise, we
              send the user back to the home page.
            */
      var oSession = store.getters['user/getSession']
      if (moment(oSession.exp * 1000).valueOf() > moment().valueOf()) {
        store.commit('setUserMenuVisible', false)
        store.commit('setLocationsMenuVisible', false)

        // Load menu data if not already loaded
        if (!store.getters['locations/getMenu']) {
          store.dispatch('locations/loadMenu');
        }

        checkMarketAccess(to, from, next);

        // IF USER IS PARTNER
        if (store.getters['user/isPartner']) {
          if (to.meta.permission != 'partner') {
            next('/partner/reports')
          } else next()
        }
        // IF USER IS ADMIN
        else if (
          typeof to.meta.permission === 'undefined' ||
          store.getters['user/isAdmin']
        ) {
          next()
        } else next('/')
      } else {
        store.dispatch('logout').then(function () {
          next({ name: 'login' })
        })
      }
    }
  }

  /*
      Confirms the user has been loaded
    */
  if (store.getters['user/getUserLoadStatus']() != 2) {
    /*
          If not, load the user
        */
    store.dispatch('loadUser').then(function () {
      // console.log( "WATCH: " + store.getters['user/getUserLoadStatus']() );
      if (store.getters['user/getUserLoadStatus']() == 2) {
        Promise.all([
          store.dispatch('loadTablesRelationship'),
          store.dispatch('orders/loadCart'),
          store.dispatch('orders/loadOrders'),
          store.dispatch('locations/loadMenu')
        ]).then(() => {
          proceed()
        });
      } else {
        store.dispatch('logout').then(function () {
          next({ name: 'login' })
        })
      }
    })
  } else {
    /*
          User call completed, so we proceed
        */
    proceed()
  }
}

// Function to check market access
function checkMarketAccess(to, from, next) {
  const market = store.getters['getMarket'];

  if (market === 'PT' && (to.name === 'diagnostic' || to.name === 'marketing')) {
    return next('/'); 
  }

  next();
}

function checkAdminMarketAccess(to, from, next) {
  const market = store.getters['getMarket'];

  if (market === 'PT' && (to.name === 'videos_edit' || to.name === 'videos_add' || to.name === 'videos' || to.name === 'import' || to.name === 'admin_mop')) {
    return next('/admin'); 
  }
  next();
}


function redirectHome (to, from, next) {
  next('/')
}

function loginUserCallbackAccess(to, from, next) {
  const encodedId = to.params.id;

  if (encodedId === 'error') {
    next({ name: 'login', query: { error: 'auth' } });
    return;
  }
  
  store.dispatch('user/processExternalLogin', encodedId)
    .then(response => {
      if (response.status) {
        store.dispatch('loadUser')
          .then(() => {
            if (store.getters['user/getUserLoadStatus']() == 2) {
              Promise.all([
                store.dispatch('loadTablesRelationship'),
                store.dispatch('orders/loadCart'),
                store.dispatch('orders/loadOrders'),
                store.dispatch('locations/loadMenu')
              ])
                .then(() => {
                  if (store.getters['user/isAdmin']) {
                    next('/admin');
                  } else if (store.getters['user/isPartner']) {
                    next('/partner/reports');
                  } else {
                    next('/');
                  }
                })
                .catch(() => {
                  next('/login?error=data');
                });
            } else {
              next('/login?error=auth');
            }
          })
          .catch(() => {
            next('/login?error=auth');
          });
      } else {
        next('/login?error=' + (response.error ? response.error.code : 'auth'));
      }
    })
    .catch(() => {
      next('/login?error=auth');
    });
}

function logoutUserCallbackAccess() {}
